import { Box, Grid } from "@mui/material"
import { PackedRect } from "../common/Models"
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded"
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded"
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined"
import { ChangeEvent, useState } from "react"
import "../App.css"
import { FortesButton } from "./FortesInputs/FortesButtons"
import COLORS from "../common/FortesColors"
import {
  FortesNumberFieldAdvanced,
  FortesNumberFieldBasic,
  FortesTextField,
} from "./FortesInputs/FortesFields"
import { rectToInch } from "../common/ForbinResolver"

export default function RectComp(props: {
  key: number
  id: string
  w: number
  h: number
  r: number
  cnt: number
  isTechnicalDrawing: boolean
  onRemove: () => void
  onChange: (ibj: PackedRect) => void
}): JSX.Element {
  const [up, Update] = useState(false)
  const [collapsed, setCollapse] = useState(false)

  const handleChangeId = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    props.onChange({
      id: e.target.value,
      w: props.w,
      h: props.h,
      r: props.r,
      cnt: props.cnt,
      isTechnicalDrawing: props.isTechnicalDrawing,
      key: props.key,
    })
    Update(!up)
  }
  const handleChangeW = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    props.onChange({
      id: props.id,
      w: Number(e.target.value),
      h: props.h,
      r: props.r,
      cnt: props.cnt,
      isTechnicalDrawing: props.isTechnicalDrawing,
      key: props.key,
    })
    Update(!up)
  }
  const handleChangeH = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    props.onChange({
      id: props.id,
      w: props.w,
      h: Number(e.target.value),
      r: props.r,
      cnt: props.cnt,
      isTechnicalDrawing: props.isTechnicalDrawing,
      key: props.key,
    })
    Update(!up)
  }
  const handleChangeR = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let newR = Number(e.target.value)
    if (newR * 2 > Math.min(props.w, props.h))
      newR = Math.min(props.w, props.h) / 2
    props.onChange({
      id: props.id,
      w: props.w,
      h: props.h,
      r: newR,
      cnt: props.cnt,
      isTechnicalDrawing: props.isTechnicalDrawing,
      key: props.key,
    })
    Update(!up)
  }
  const handleChangeCnt = (new_: number) => {
    props.onChange({
      id: props.id,
      w: props.w,
      h: props.h,
      r: props.r,
      cnt: new_,
      isTechnicalDrawing: props.isTechnicalDrawing,
      key: props.key,
    })
    Update(!up)
  }

  const handleRemove = () => {
    props.onRemove()
    Update(!up)
  }

  const diagonal =
    Math.round(rectToInch({ w: props.w, h: props.h }) * 100) / 100

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${COLORS.separator}`,
        backgroundColor: !collapsed ? COLORS.backgroundBlue : "white",
      }}
    >
      <Grid
        container
        height={"85px"}
        direction="row"
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ marginBlockEnd: "10px" }}
      >
        <Box sx={{ marginBlockStart: "15px" }}>
          {collapsed ? (
            <FortesButton
              width="40px"
              height="40px"
              onClick={() => {
                setCollapse(false)
              }}
            >
              <KeyboardArrowDownRoundedIcon />
            </FortesButton>
          ) : (
            <FortesButton
              width="40px"
              height="40px"
              onClick={() => {
                setCollapse(true)
              }}
            >
              <KeyboardArrowRightRoundedIcon />
            </FortesButton>
          )}
        </Box>

        <FortesTextField
          label={"Name"}
          initalValue={props.id}
          enabled={!props.isTechnicalDrawing}
          onChange={handleChangeId}
        />
        <Box sx={{ marginBlockStart: "15px" }}>
          <FortesButton width="40px" height="40px" onClick={handleRemove}>
            <DeleteOutlineOutlinedIcon />
          </FortesButton>
        </Box>
      </Grid>

      {!collapsed && (
        <>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            sx={{ margin: "20px 20px 10px 20px" }}
            width="410px"
          >
            <FortesNumberFieldBasic
              label={"Width (mm)"}
              initalValue={props.w}
              onChange={handleChangeW}
            />
            <FortesNumberFieldBasic
              label={"Height (mm)"}
              initalValue={props.h}
              onChange={handleChangeH}
            />
            <FortesNumberFieldBasic
              width="SMedium"
              label={'Diagonal (")'}
              initalValue={diagonal}
              onChange={() => {}}
              enabled={false}
            />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            sx={{ margin: "10px 20px 30px 20px" }}
            width="410px"
          >
            <FortesNumberFieldBasic
              label={"Corner radius (mm)"}
              width="SMedium"
              initalValue={props.r}
              onChange={handleChangeR}
            />
            <FortesNumberFieldAdvanced
              label={"Count"}
              initalValue={props.cnt}
              enabled={true}
              onChange={handleChangeCnt}
            />
          </Grid>
        </>
      )}
    </Box>
  )
}
